import { gql, useApolloClient } from '@apollo/client';
import React from 'react';
import { PostEditorEditViewProps } from './PostEditorEdit.view';
import { PostEditorEditController } from './PostEditorEdit.controller';
import { useDidMount } from '../../../hooks/useDidMount';

gql`
  query GetPostsEditor($postId: ID!) {
    latestFamilyMembersOfPost(postId: $postId) {
      ...PostItem
    }
  }
`;

export type PostEditorEditApolloProps = {
  //
  postId: PostEditorEditViewProps['postId'];
};

export const PostEditorEditApollo = (props: PostEditorEditApolloProps): JSX.Element => {
  const { cache } = useApolloClient();
  const { postId } = props;
  // Since our familyMembers query has been cached, and we need to have a fresh result on each edit, we need to clear
  // that query from the cache
  useDidMount(() => () => {
    cache.evict({ id: 'ROOT_QUERY', fieldName: 'latestFamilyMembersOfPost', args: { postId } });
    cache.evict({ id: 'ROOT_QUERY', fieldName: 'post', args: { postId } });
    cache.gc();
  });
  return <PostEditorEditController {...props} />;
};
